import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import Charts from './content/pages/charts';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const PgeDashboard = Loader(lazy(() => import('src/content/dashboards/PGE')));
const PGEWebHealth = Loader(lazy(() => import('src/content/pge-web-health')));
const C2mInfo = Loader(lazy(() => import('src/content/c2m-info')));
const OicInfo = Loader(lazy(() => import('src/content/oic/index')));
const AlertsEnrolled = Loader(lazy(() => import('src/content/alerts/index')));
const PaymentChannels = Loader(
  lazy(() => import('src/content/payment-channels'))
);
const TransactionHealth = Loader(
  lazy(() => import('src/content/transaction-health'))
);
const NotificationReport = Loader(
  lazy(() => import('src/content/notification-report'))
);
const RniDashboard = Loader(lazy(() => import('src/content/rni-dashboard')));
const NonProdSecurity = Loader(
  lazy(() => import('src/content/non-prod-security'))
);
const DiagnosticsDashboard = Loader(
  lazy(() => import('src/content/diagnostics'))
);
const WorkflowFailures = Loader(lazy(() => import('src/content/temporal')));
const SyntheticHealth = Loader(
  lazy(() => import('src/content/synthetic-health'))
);
const AppToggles = Loader(lazy(() => import('src/content/app-toggles')));

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <PgeDashboard />
      }
    ]
  },
  {
    path: '/charts',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Charts />
      }
    ]
  },
  {
    path: '/pge-web-health',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <PGEWebHealth />
      }
    ]
  },
  {
    path: '/synthetic-health',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <SyntheticHealth />
      }
    ]
  },
  {
    // Nav visibility is cosmetic — this route is reachable by URL like every other one.
    // Authorization is enforced server-side in AppTogglesManager.
    path: '/app-runtime-config',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AppToggles />
      }
    ]
  },
  {
    path: '/transaction-health',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <TransactionHealth />
      }
    ]
  },
  {
    path: '/payment-channels',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <PaymentChannels />
      }
    ]
  },
  {
    path: '/c2m-info',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <C2mInfo />
      }
    ]
  },
  {
    path: '/oic-info',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <OicInfo />
      }
    ]
  },
  {
    path: '/alerts-enrolled',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AlertsEnrolled />
      }
    ]
  },
  {
    path: '/notification-report',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <NotificationReport />
      }
    ]
  },
  {
    path: '/rni-dashboard',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <RniDashboard />
      }
    ]
  },
  {
    path: '/non-prod-security',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <NonProdSecurity />
      }
    ]
  },
  {
    path: '/diagnostics',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <DiagnosticsDashboard />
      }
    ]
  },
  {
    path: '/temporal/workflow-failures',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <WorkflowFailures />
      }
    ]
  },
  {
    path: '/*',
    element: <Status404 />
  }
];

export default routes;
